const getImageCropType = imageCropOption => {
  if (imageCropOption.isFreeRatio) {
    return 'free';
  }

  if (imageCropOption.width > imageCropOption.height) {
    return 'horizontal';
  }

  if (imageCropOption.height > imageCropOption.width) {
    return 'vertical';
  }

  return 'square';
};

export default getImageCropType;
